import finishItinerary from './finish-itinerary-service';

export default finishItinerary;
